import styled from 'styled-components';
import { readableColor } from 'polished';
import ButtonBase from '../base/Base';

const ButtonCompactPrimary = styled(ButtonBase)`
  min-width: 120px;
  background-color: ${props => (props.theme.global.colors.buttonColor)};
  margin: ${props => (props.margin || null)};
  color: ${props => (props.theme.global.colors.buttonColor === '#007DC6' ? '#fff' : readableColor(props.theme.global.colors.buttonColor))};
  padding: .5rem 2rem;
`;

export default ButtonCompactPrimary;



// WEBPACK FOOTER //
// ./src/components/atoms/buttons/compact/Primary.js